import { render, staticRenderFns } from "./dialogView.vue?vue&type=template&id=37d869f8&scoped=true"
import script from "./dialogView.vue?vue&type=script&lang=js"
export * from "./dialogView.vue?vue&type=script&lang=js"
import style0 from "./dialogView.vue?vue&type=style&index=0&id=37d869f8&prod&lang=less&scoped=true"
import style1 from "./dialogView.vue?vue&type=style&index=1&id=37d869f8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d869f8",
  null
  
)

export default component.exports